import React from 'react'
import styled from 'styled-components'

import Box from '@/modules/components/Box'
import Flex from '@/modules/components/Flex'
import { mobileFirstDevice } from '@/modules/media-queries'

import { certificates } from './data'

const StyledContainer = styled(Flex)`
  align-items: center;
  justify-content: flex-start;
  max-width: 250px;
  flex-wrap: wrap;
  margin: auto !important;

  @media ${mobileFirstDevice.tablet} {
    align-items: center;
    justify-content: flex-start;
    margin: 0 !important;
  }
  @media ${mobileFirstDevice.laptop} {
    align-items: center;
    justify-content: flex-start;
  }
`

export const Certificates = () => {
  return (
    <StyledContainer>
      {certificates.map(
        ({ src, width, margin, marginRight, opacity }, index) => (
          <Box
            key={index}
            width={width}
            margin={margin}
            marginRight={marginRight}
            opacity={opacity}
          >
            <img src={src} width="100%" />
          </Box>
        )
      )}
    </StyledContainer>
  )
}
